import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '../Components/ui/container';
import { Inline } from '../Components/ui/layout';
import { Button } from '../Components/ui/button';

const Header = () => {
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check token in localStorage to determine login state
  useEffect(() => {
    const token = localStorage.getItem('token'); 
    setIsLoggedIn(!!token);
  }, []);

  const handleLoginForm = () => {
    navigate('/login');
  };

  const handleSignUp = () => {
    navigate('/signup');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/');
  };

  const handleHireWithUs = () => {
    navigate('/hirewithus');
  };

  return (
    <header className="sticky top-0 z-sticky bg-background border-b border-border shadow-sm">
      <Container size="full">
        <Inline justify="between" align="center" className="py-md">
          <img
            className="h-10 w-auto cursor-pointer"
            src="/Newzenalphablue.png"
            alt="Logo"
            onClick={() => navigate('/')}
          />
          <nav className="hidden md:block">
            <Inline spacing="lg" as="ul" className="list-none">
              <li>
                <a href="/jobpage" className="text-foreground hover:text-primary transition-colors font-medium">
                  Jobs
                </a>
              </li>
              <li>
                <a href="/explore" className="text-foreground hover:text-primary transition-colors font-medium">
                  Explore
                </a>
              </li>
              <li>
                <a href="/trends" className="text-foreground hover:text-primary transition-colors font-medium">
                  Trends
                </a>
              </li>
              <li>
                <a href="#category" className="text-foreground hover:text-primary transition-colors font-medium">
                  Category
                </a>
              </li>
            </Inline>
          </nav>
          <Inline spacing="sm" align="center">
            <Button variant="secondary" onClick={handleHireWithUs}>
              Hire with US
            </Button>
            {!isLoggedIn ? (
              <>
                <Button variant="outline" onClick={handleLoginForm}>
                  Login
                </Button>
                <Button variant="default" onClick={handleSignUp}>
                  Join now
                </Button>
              </>
            ) : (
              <Button variant="outline" onClick={handleLogout}>
                Logout
              </Button>
            )}
          </Inline>
        </Inline>
      </Container>
    </header>
  );
};

export default Header;
